import encodeHtmlSpecialChars from './encodeHtmlSpecialChars'
import replaceMergeTags from './replaceMergeTags'
import markdownToHtml from './markdownToHtml'
import escapeRegEx from './escapeRegEx'
import hash from './hash'

export default { encodeHtmlSpecialChars, replaceMergeTags, markdownToHtml, escapeRegEx, hash }
